<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="报文内容" prop="content">
                <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入报文内容"
                    v-model="ruleForm.content"></el-input>
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">发送</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { sendTest } from "@/api/device/index.js";
export default {
    props: ["subData"],
    data() {
        return {
            ruleForm: {
                content: "",
            },
            rules: {
                content: [
                    { required: true, message: "请输入报文内容", trigger: "blur" },
                ]
            },
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    sendTest({
                        msg: this.ruleForm.content
                    }).then(res => {
                        this.$message({
                            message: "发送成功",
                            type: "success",
                        });
                        this.$parent.close();
                    }).catch(e => {
                        console.error(e);
                    });

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>